import { FC } from 'react';
import { Button } from '@marriott/mi-ui-library';
import { StyledRoomCard } from './RoomCard.styles';
import { RoomCardProps } from './RoomCard.types';
import { formatAmount, getFormattedDate, formatUTCDate } from '../../../../../../../utils';

export const RoomCard: FC<RoomCardProps> = ({
  labels,
  data,
  roomIndex,
  hasError,
  isMarshaProperty = true,
  onRemove,
  onUndoRemove,
}) => {
  const { rates, to, maxGuests, groupCodeLabel, inventoryCodeLabel, roomTypeLabel, perNight, remove, undo } = labels;
  const { fromDate, toDate, maxOccupancy, groupCode, inventoryTypeCode, roomType, roomRate, currency, isRemoved } =
    data;

  const showDates = () => {
    if (fromDate && toDate) {
      const formattedStartDate = getFormattedDate(formatUTCDate(fromDate), 'dateWithMonthNoAndShortYear');
      const formattedEndDate = getFormattedDate(formatUTCDate(toDate), 'dateWithMonthNoAndShortYear');

      return (
        <span className="t-label-inverse-alt-xs">
          {formattedStartDate}
          {(formattedStartDate !== formattedEndDate || isMarshaProperty) && (
            <>
              {' '}
              {to} {formattedEndDate}
            </>
          )}
        </span>
      );
    } else return null;
  };

  return (
    <StyledRoomCard hasError={hasError} isRemoved={isRemoved} className="row justify-content-between py-4 px-3 m-0">
      <div className="row col-12 col-lg-9">
        <div className="col-3 col-md-2"></div>
        <div className="col-5 col-md-3">
          <span className="d-block t-font-xs">{rates}</span>
          {showDates()}
        </div>
        <div className="col-4 col-md-2">
          <span className="d-block t-font-xs">{maxGuests}</span>
          <span className="t-label-inverse-alt-xs">{maxOccupancy}</span>
        </div>
        <div className="col-3 col-md-0 d-md-none"></div>
        <div className="col-5 col-md-2 mt-3 mt-md-0">
          <span className="d-block t-font-xs">{groupCode ? groupCodeLabel : inventoryCodeLabel}</span>
          <span className="t-label-inverse-alt-xs group-code">{groupCode || inventoryTypeCode}</span>
        </div>
        <div className="col-4 col-md-3 mt-3 mt-md-0">
          <span className="d-block t-font-xs">{roomTypeLabel}</span>
          <span className="t-label-inverse-alt-xs">{roomType}</span>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-end col-12 col-lg-3 mt-3 mt-md-0">
        <div className="mr-3">
          <span className="m-price">{roomRate === '-' ? roomRate : formatAmount(+(roomRate || 0))}</span>
          {roomRate && roomRate !== '-' ? (
            <span className="t-font-xs">
              {' '}
              {currency}
              {perNight}
            </span>
          ) : null}
        </div>
        {groupCode ? (
          isRemoved ? (
            <Button className="cta-icon" ariaLabel={undo} callback={() => onUndoRemove(roomIndex)}>
              <span className="t-font-xs cta-icon-label">{undo}</span>
              <span className="icon-renew"></span>
            </Button>
          ) : (
            <Button className="cta-icon" ariaLabel={remove} callback={() => onRemove(roomIndex)}>
              <span className="t-font-xs cta-icon-label">{remove}</span>
              <span className="icon-clear"></span>
            </Button>
          )
        ) : null}
      </div>
    </StyledRoomCard>
  );
};
